import getNotifications from './getNotifications'
import markAsRead from './markAsRead'
import readAll from './readAll'

export default {
  getNotifications,
  markAsRead,
  readAll,
}
